export default __webpack_public_path__ + "static/media/46264_22-36.c14d70e5.jpg";